<div class="modal-header modal-header-center" #modal *ngIf="type !== 'report'">
  <h4 class="font-primary--b">{{ title }}</h4>
</div>

<div class="modal-body" *ngIf="type !== 'report'">
  <div class="text-center">
    <div class="spinner-border" role="status"></div>
  </div>
  <br />
  <p *ngIf="content" class="font-regular modal-text-center">{{ content }}.</p>
</div>

<!-- Custom Report Generation Loader -->
<div class="modal-body pdf-generation-loader" *ngIf="type === 'report'">
  <div class="pdf-generation-container">
    <!-- Animated Icons -->
    <div class="download-icons-container">
      <svg class="download-icon icon-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path>
      </svg>
      <svg class="download-icon icon-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
      </svg>
      <svg class="download-icon icon-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
      </svg>
    </div>

    <!-- Text -->
    <h2 class="text-center font-18 font-primary--b mt-4 mb-3 report-title">
      {{ title }}
    </h2>

    <!-- Progress Bar -->
    <div class="progress-bar-container">
      <div class="progress-bar">
        <div class="progress-bar-fill"></div>
      </div>
    </div>
  </div>
</div>
